'use client';

import React, { useEffect, useRef } from 'react';

interface ReadRawHTMLProps {
  html?: string;
}

const removeInlineStyles = (html: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const elementsWithStyle = doc.querySelectorAll('[style]');
  elementsWithStyle.forEach((element) => {
    const isInChartContainer =
      element.closest('.vietstats-chart-container') !== null;

    const isItem = element.closest('.elementor-widget-container') !== null;

    if (!isInChartContainer && isItem) {
      element.removeAttribute('style');
    }
  });

  return doc.body.innerHTML;
};

const ReadRawHTML: React.FC<ReadRawHTMLProps> = ({ html }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current && html) {
      const oldScripts = containerRef.current.querySelectorAll('script');
      oldScripts.forEach((s) => s.remove());

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = removeInlineStyles(html);

      const scripts = tempDiv.querySelectorAll('script');
      scripts.forEach((script) => {
        const newScript = document.createElement('script');
        for (let i = 0; i < script.attributes.length; i++) {
          const attr = script.attributes[i];
          newScript.setAttribute(attr.name, attr.value);
        }
        newScript.text = script.text;
        containerRef.current?.appendChild(newScript);
      });
    }
  }, [html]);

  return (
    <div
      className={'m-richtext_editor m-rich-text-viewer'}
      ref={containerRef}
      dangerouslySetInnerHTML={{ __html: html ? removeInlineStyles(html) : '' }}
      style={{ width: '100%' }}
    />
  );
};

export default ReadRawHTML;
